import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsBefore } from "../../dateutil";
import moment from 'moment-timezone';

class BeforeDateEx extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      let current = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('YYYY-MM-DD');
      let compare = moment(validation.value).utcOffset(moment(validation.value).utcOffset()).format('YYYY-MM-DD');
      if ( !dateIsBefore(current, compare)) {
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_BEFORE_SPECIFIED_DATE_EX',
          values: { value: validation.value },
          message: `Value should be before '${compare}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default BeforeDateEx;
